@if (selectedSite?.id) {
  <div class="py-2 text-center">
    <span class="text-secondary"> Updates for </span>
    <span class="fw-bold">{{ selectedSite?.company_name }}</span>
  </div>
}
@if (largeView) {
  <gtapp-gt-custom-table
    [deskTopTableData]="userEvents"
    [desktopTableDetails]="userEventDetailsTableView"
    [tableStyle]="tableStyle"
    [otherParams]="otherParams"
    (rowClick)="onTableRowClick($event)"
    (sortColumn)="sortColumn($event)"
    (searchColumn)="searchColumn($event)"
    (paginationChange)="onPaginationChange($event)"
  ></gtapp-gt-custom-table>
} @else {
  @if (!selectedEvent) {
    <gtapp-infinite-list
      [mobileCardBackendData]="infiniteDataList"
      [mobileCardDetails]="userEventDetailsMobileView"
      [mobileActionIcons]="cardActionIcons"
      [totalRows]="totalRows"
      (actionClick)="onCardActionIconClick($event, commentRef)"
      (loadMoreData)="loadMoreMobileData()"
      (rowClick)="onTableRowClick($event)"
      (sortColumn)="sortColumn($event)"
      (searchColumn)="searchColumn($event)"
    ></gtapp-infinite-list>
  }
}
@if (selectedEvent) {
  <gtapp-selected-event-detail
    [selectedEvent]="selectedEvent"
    selectedEventFrom="user_update_history"
    [userEventDetailsTableView]="userEventDetailsTableView"
    [extraCheck]="true"
    (goBack)="hideDetails()"
    (editUserComment)="editComment($event, commentRef)"
    (deleteRestoreUserUpdate)="deleteRestoreUserUpdate($event)"
  ></gtapp-selected-event-detail>
}

<!-- Edit Comment Popover/Dialog -->
<ng-template #commentRef let-commentRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      {{ data?.detail ? "Edit Comment" : "Add Comment" }}
      <span class="float-end" (click)="commentRef.close(); newComment = ''">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="5"
          cols="32"
          wrap="hard"
          maxlength="340"
          type="text"
          autofocus
          placeholder="Start typing"
          [(ngModel)]="newComment"
          id="updateCommentBox"
        ></textarea>
        @if (newComment) {
          <span
            class="input-group-text"
            (click)="clearAndFocusTextBox('updateCommentBox')"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="commentRef.close(); newComment = ''"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          @if (
            data?.id &&
            data?.event_type === "Patrol Update" &&
            [2, 7].includes(data?.event_action)
          ) {
            <button
              class="btn btn-lg w-100"
              [disabled]="previousComment === newComment"
              (click)="addComment(data); commentRef.close()"
              [ngClass]="newComment ? 'btn-primary' : 'btn-danger'"
            >
              Update
            </button>
          } @else {
            <button
              class="btn btn-primary btn-lg w-100"
              [disabled]="!newComment || previousComment === newComment"
              (click)="addComment(data); commentRef.close()"
            >
              {{ data?.id ? "Update" : "Add" }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
